<template>
  <BoxCube v-if="item&&item.type==='box'" :item="item"/>
  <TextBox v-else-if="item&&item.type==='text'" :item="item"></TextBox>
  <ImageBox v-else-if="item&&item.type==='image'" :item="item"></ImageBox>
  <IconBox v-else-if="item&&item.type==='icon'" :item="item"></IconBox>
  <BtnBox v-else-if="item&&item.type==='button'" :item="item"></BtnBox>
  <hr v-else-if="item&&item.type==='separator'" :style="[
    item.margin?{
      marginTop: item.margin === 'xs' ? '2px'
      : item.margin === 'sm' ? '4px'
      : item.margin === 'md' ? '8px'
      : item.margin === 'lg' ? '12px'
      : item.margin === 'lg' ? '12px'
      : item.margin === 'xl' ? '16px'
      : item.margin === 'xxl' ? '20px'
      : item.margin
    }:{},
    item.color?{borderColor: item.color}:{},
    {width: '100%'}
  ]">
  <div class="mdBxFiller" v-else-if="item&&item.type==='filler'"></div>
  <div v-else>{{item.type}}</div>
</template>

<script>
export default {
  props: ['item']
}
</script>
<style lang="scss" scoped>
* {
  line-height: 1.4;
}
.mdBxFiller {
  -webkit-box-flex: 1;
  flex: 1 0 0;
}
</style>
